"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendNaverPay = void 0;
exports.backendNaverPay = function (axios) {
    return {
        putNaverPayDelayProductOrder: function (request) {
            return axios.put('/naver-pay/delayProductOrder', request.data);
        },
        putNaverPaySyncProductOrder: function (request) {
            var orderNo = request.params.orderNo;
            return axios.put("/naver-pay/syncProductOrder?orderNo=" + orderNo);
        },
        getNaverPayValidDelayProductOrder: function (request) {
            var orderOptionNos = request.params.orderOptionNos;
            return axios.get("/naver-pay/validDelayProductOrder?orderOptionNos=" + orderOptionNos);
        }
    };
};
